import { render, staticRenderFns } from "./collectHistory.vue?vue&type=template&id=8ef64fd8&scoped=true&"
import script from "./collectHistory.vue?vue&type=script&lang=js&"
export * from "./collectHistory.vue?vue&type=script&lang=js&"
import style0 from "./collectHistory.vue?vue&type=style&index=0&id=8ef64fd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef64fd8",
  null
  
)

export default component.exports